import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminClientApi, AdminLoginInputInterface, AdminApiError } from '../../Admin-ClientLibrary';
import { useAuth } from '../../contexts/AuthContext';
import { getApiUrl } from '../../config/api';
import './AdminLogin.css';

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  // Create a temporary API client for login (no token needed)
  const loginApi = new AdminClientApi(getApiUrl(), () => '');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const loginData: AdminLoginInputInterface = { email, password };
      const response = await loginApi.adminLogin(loginData);

      if (response.user && response.token) {
        // Use AuthContext to handle login state and localStorage
        login(response.token, response.user);
        
        // Navigate to dashboard
        navigate('/dashboard');
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (err) {
      if (err instanceof AdminApiError) {
        if (err.statusCode === 401) {
          setError('Invalid email or password.');
        } else if (err.statusCode === 403) {
          setError('Access denied. Administrator privileges required.');
        } else {
          setError(err.message || 'Login failed. Please try again.');
        }
      } else {
        setError('Network error. Please check your connection and try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-container">
        <div className="admin-login-header">
          <h1>EPIST Admin Portal</h1>
          <p>Sign in to access the admin dashboard</p>
        </div>
        
        <form className="admin-login-form" onSubmit={handleSubmit}>
          {error && <div className="admin-login-error">{error}</div>}
          
          <div className="admin-form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              placeholder="admin@example.com"
            />
          </div>
          
          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
              placeholder="Enter your password"
            />
          </div>
          
          <button 
            type="submit" 
            className="admin-login-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        
        <div className="admin-login-footer">
          <p>Administrator access only</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;